import { render, staticRenderFns } from "./ModalItemPriceSchedule.vue?vue&type=template&id=8004c314&scoped=true"
import script from "./ModalItemPriceSchedule.vue?vue&type=script&lang=js"
export * from "./ModalItemPriceSchedule.vue?vue&type=script&lang=js"
import style0 from "./ModalItemPriceSchedule.vue?vue&type=style&index=0&id=8004c314&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004c314",
  null
  
)

export default component.exports